import { HourCodeService, IHourCode } from "../../../services/hourCode.service";
import { SalaryScaleGroupService, ISalaryScaleGroup } from "../../../services/salaryScaleGroup.service";
import { NmbrsService, INmbrsHourCode, INmbrsWageCode } from "../../../services/nmbrs.service";

interface IResolve {
    hourCode: IHourCode;
}

class HourCodesItemBasicController {

    private resolve: IResolve;
    private hourCode: IHourCode;
    salaryScaleGroups: ISalaryScaleGroup[] = [];
    private close: any;
    typeSelect: string; // String value for AngularJS select
    nmbrsCodes: Array<{code: number, description: string}> = [];
    loadingCodes: boolean = false;

    constructor(
        private HourCodeService: HourCodeService,
        private SalaryScaleGroupService: SalaryScaleGroupService,
        private NmbrsService: NmbrsService,
        private $state: ng.ui.IStateService,
        private $stateParams: ng.ui.IStateParamsService,
        private $timeout: ng.ITimeoutService,
        private SweetAlert: any
    ) {
        'ngInject';
    }

    public $onInit = () => {        
        if (this.resolve.hourCode) {
            this.hourCode = this.resolve.hourCode;
            // Convert type to string for AngularJS select
            if (this.hourCode.type !== undefined && this.hourCode.type !== null) {
                this.typeSelect = String(this.hourCode.type);
            } else {
                this.typeSelect = '0'; // Default to Looncomponent
                this.hourCode.type = 0;
            }
            
            // Zorg dat value2 een string is (voor eenheid)
            if (this.hourCode.value2 === null || this.hourCode.value2 === undefined) {
                this.hourCode.value2 = '';
            } else {
                // Zorg dat het een string is (voor backward compatibility)
                this.hourCode.value2 = String(this.hourCode.value2);
            }
        } else {
            // Get caoId from state params if available (for new hourcodes)
            const caoId = this.$stateParams['caoId'];
            this.hourCode = {
                code: '',
                name: '',
                description: '',
                twinfieldCode: '',
                value: null,
                value2: '',
                salaryScaleGroupId: caoId || null,
                type: 0, // Default: Looncomponent
            } as any as IHourCode;
            this.typeSelect = '0'; // Default for select
        }

        // Load salary scale groups
        this.SalaryScaleGroupService.all().then((result: ISalaryScaleGroup[]) => {
            // Sort alphabetically by name
            this.salaryScaleGroups = result.sort((a, b) => {
                if (a.name < b.name) return -1;
                if (a.name > b.name) return 1;
                return 0;
            });
            
            // Trigger chosen update after data is loaded
            this.$timeout(() => {
                if ((<any>window).jQuery && (<any>window).jQuery.fn.chosen) {
                    (<any>window).jQuery('select[name="salaryScaleGroup"]').trigger('chosen:updated');
                }
            }, 0);
        });

        // Load NMBRS codes based on initial type
        // Use a small delay to ensure typeSelect is set
        this.$timeout(() => {
            this.loadNmbrsCodes();
        }, 100);
    }

    public $onChanges = (changes: any) => {
        // Update chosen dropdown when nmbrsCodes changes
        if (changes.nmbrsCodes && !changes.nmbrsCodes.isFirstChange()) {
            this.$timeout(() => {
                if ((<any>window).jQuery && (<any>window).jQuery.fn.chosen) {
                    (<any>window).jQuery('select[name="code"]').trigger('chosen:updated');
                }
            }, 0);
        }
    }

    /**
     * Laadt NMBRS codes op basis van het geselecteerde type
     */
    public loadNmbrsCodes = () => {
        this.loadingCodes = true;
        const currentCode = this.hourCode.code; // Bewaar huidige code
        this.nmbrsCodes = [];
        
        const type = parseInt(this.typeSelect || '0', 10);
        
        if (type === 0) {
            // Looncomponent: gebruik hourCodes
            this.NmbrsService.getHourCodes().then((codes: INmbrsHourCode[]) => {
                this.nmbrsCodes = codes.map(c => ({
                    code: c.code,
                    description: c.description || ''
                })).sort((a, b) => a.code - b.code);
                this.loadingCodes = false;
                
                // Herstel code als deze bestaat in de nieuwe lijst
                if (currentCode) {
                    const codeExists = this.nmbrsCodes.some(c => String(c.code) === String(currentCode));
                    if (codeExists) {
                        this.hourCode.code = String(currentCode);
                    }
                }
                
                // Update chosen dropdown
                this.$timeout(() => {
                    if ((<any>window).jQuery && (<any>window).jQuery.fn.chosen) {
                        (<any>window).jQuery('select[name="code"]').trigger('chosen:updated');
                    }
                }, 0);
            }).catch((error) => {
                console.error('Error loading NMBRS hourCodes:', error);
                this.loadingCodes = false;
            });
        } else if (type === 1) {
            // Onkosten: gebruik wageCodes
            this.NmbrsService.getWageCodes().then((codes: INmbrsWageCode[]) => {
                this.nmbrsCodes = codes.map(c => ({
                    code: c.code,
                    description: c.description || ''
                })).sort((a, b) => a.code - b.code);
                this.loadingCodes = false;
                
                // Herstel code als deze bestaat in de nieuwe lijst
                if (currentCode) {
                    const codeExists = this.nmbrsCodes.some(c => String(c.code) === String(currentCode));
                    if (codeExists) {
                        this.hourCode.code = String(currentCode);
                    }
                }
                
                // Update chosen dropdown
                this.$timeout(() => {
                    if ((<any>window).jQuery && (<any>window).jQuery.fn.chosen) {
                        (<any>window).jQuery('select[name="code"]').trigger('chosen:updated');
                    }
                }, 0);
            }).catch((error) => {
                console.error('Error loading NMBRS wageCodes:', error);
                this.loadingCodes = false;
            });
        } else {
            this.loadingCodes = false;
        }
    }

    /**
     * Wordt aangeroepen wanneer het type verandert
     */
    public onTypeChange = () => {
        // Reset code en naam wanneer type verandert
        this.hourCode.code = '';
        this.hourCode.name = '';
        // Laad nieuwe codes (code wordt niet gereset in loadNmbrsCodes omdat we het hier al doen)
        this.loadNmbrsCodes();
    }

    /**
     * Wordt aangeroepen wanneer een code wordt geselecteerd
     */
    public onCodeChange = () => {
        // Auto-fill naam op basis van geselecteerde code
        if (this.hourCode.code) {
            const selectedCode = this.nmbrsCodes.find(c => String(c.code) === String(this.hourCode.code));
            if (selectedCode && !this.hourCode.name) {
                this.hourCode.name = selectedCode.description;
            }
        }
    }

    submitHourCode() {
        // Convert typeSelect string to number before submitting
        this.hourCode.type = parseInt(this.typeSelect, 10);
        
        // Ensure code is a string (convert from number if needed)
        if (this.hourCode.code !== null && this.hourCode.code !== undefined) {
            this.hourCode.code = String(this.hourCode.code);
        }
        
        // Handle value (prijs per eenheid) en value2 (eenheid) - alleen voor Onkosten (type 1)
        if (this.hourCode.type === 1) {
            // Voor Onkosten: value bevat prijs per eenheid, value2 bevat de eenheid als tekst
            // Zorg dat value2 een string is (of null als leeg)
            if (!this.hourCode.value2 || (typeof this.hourCode.value2 === 'string' && this.hourCode.value2.trim() === '')) {
                this.hourCode.value2 = null;
            } else if (typeof this.hourCode.value2 !== 'string') {
                // Zorg dat het een string is
                this.hourCode.value2 = String(this.hourCode.value2);
            }
            // value (prijs per eenheid) blijft zoals het is voor Onkosten
        } else {
            // Voor Looncomponent: value en value2 niet gebruiken
            this.hourCode.value = null;
            this.hourCode.value2 = null;
        }
        
        if (this.hourCode.id === undefined) {
            this.HourCodeService.post(this.hourCode).then((result: any) => {
                // Preserve selected CAO when navigating back
                const selectedCaoId = this.hourCode.salaryScaleGroupId || this.$stateParams['caoId'];
                this.$state.go('settings.hourcodes.list', { 'selectedCaoId': selectedCaoId }, {reload: true});
            });
        } else {
            this.HourCodeService.put(this.hourCode.id, this.hourCode).then(result => {
                // Preserve selected CAO when navigating back
                const selectedCaoId = this.hourCode.salaryScaleGroupId;
                this.$state.go('settings.hourcodes.list', { 'selectedCaoId': selectedCaoId }, {reload: true});
            });
        }
    }

    deleteHourCode() {
        this.SweetAlert.swal({
            title: 'Weet je het zeker?',
            text: "Je kunt dit niet ongedaan maken!",
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ja, verwijderen!',
            cancelButtonText: 'Nee, annuleren!',
        }, (isConfirm) => {
            if (isConfirm) {
                this.HourCodeService.delete(this.hourCode.id).then(() => {
                    const selectedCaoId = this.hourCode.salaryScaleGroupId;
                    this.$state.go('settings.hourcodes.list', { 'selectedCaoId': selectedCaoId }, {reload: true});
                });
            }
        });
    }

    public closeModal = () => {
        // Preserve selected CAO when closing modal
        const selectedCaoId = this.hourCode.salaryScaleGroupId || this.$stateParams['caoId'];
        
        // Navigate back to list with selected CAO preserved
        this.$state.go('settings.hourcodes.list', { 'selectedCaoId': selectedCaoId || null }, { reload: false });
    }
}

export const hourCodesItemBasicComponent = { 
    bindings: {
        resolve : "<",
        close: "&"
    },
    controller: HourCodesItemBasicController,
    template: require('./hourCodes.item.basic.html')
};




// WEBPACK FOOTER //
// ./src/app/modules/settings/hourCodes/hourCodes.item.basic.component.ts